import { render, staticRenderFns } from "./getTicketMethods.vue?vue&type=template&id=b4e4092e&scoped=true&"
import script from "./getTicketMethods.vue?vue&type=script&lang=ts&"
export * from "./getTicketMethods.vue?vue&type=script&lang=ts&"
import style0 from "./getTicketMethods.vue?vue&type=style&index=0&id=b4e4092e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e4092e",
  null
  
)

export default component.exports